export function getAppConfigRouteData() {
  const route = useRoute()

  return {
    identifier: route.params?.identifier ?? '',
    slug: route.params?.slug ?? '',
    moduleIdentifier: route.params?.moduleIdentifier ?? ''
  }
}
